import React, { useState, useEffect } from 'react';
import EscalaPNG from '../images/escala de profissionais.png';
import PaineisPNG from '../images/paineis.png';
import AtividadesPNG from '../images/atividades.png';
import CalculoPNG from '../images/calculo.png';
import EventosPNG from '../images/eventos.png';
import AdcionarPNG from '../images/adcionarEvento.png';
import CalendarioPNG from '../images/calendario interno.png';
import Monitoramento from '../images/monitoramento.png';
import MonitoramentoSUBHUE from '../images/HOSPITAIS.png';
import GestaoBiblioteca from '../images/biblioteca-sub.png';
import HCIPNG from '../images/hci.jpeg';
import Parcerias from '../images/parcerias.png';
import SafetyHuddlePNG from '../images/safetyHuddle.png';
import AvcAcompanhamentoIcon from '../images/avc/acompanhamento-avc.svg';
import Cookies from 'js-cookie';

// SVG Components
const GearSVG = () => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='140'
		viewBox='0 0 90 74'
		fill='none'>
		<path
			d='M41.5275 46.4804C41.7841 48.0559 42.4542 49.5006 43.4027 50.7013C41.6633 52.9008 40.8553 55.9185 41.8241 59.0418L41.825 59.0447C42.4507 61.0535 43.298 63.0231 44.3995 64.9183C45.4981 66.8087 46.7854 68.5275 48.2286 70.0732C48.5422 70.4093 48.8717 70.714 49.2142 70.9884L4.63499 71C4.63484 71 4.63469 71 4.63454 71C3.65544 70.9998 2.8808 70.212 2.8808 69.2654C2.8808 56.6131 13.181 46.3438 25.9202 46.3438H39.0123C39.858 46.3438 40.6987 46.3913 41.5275 46.4804ZM32.4663 3C36.6696 3 40.6984 4.66216 43.6671 7.61715C46.6353 10.5717 48.3008 14.5766 48.3008 18.75C48.3008 22.9234 46.6353 26.9283 43.6671 29.8829C40.6984 32.8378 36.6696 34.5 32.4663 34.5C28.263 34.5 24.2341 32.8378 21.2654 29.8829C18.2972 26.9283 16.6317 22.9234 16.6317 18.75C16.6317 14.5766 18.2972 10.5717 21.2654 7.61715C24.2341 4.66216 28.263 3 32.4663 3Z'
			stroke='white'
			strokeWidth='5'
		/>
		<path
			d='M63.6368 33.794C63.6368 32.9008 64.211 32.0969 65.0787 31.9055C66.4185 31.5992 67.8222 31.4333 69.2514 31.4333C70.6805 31.4333 72.0842 31.5992 73.424 31.9055C74.2917 32.0969 74.8659 32.9008 74.8659 33.794V37.6987C75.874 38.1326 76.831 38.6813 77.7115 39.332L80.8889 37.5073C81.6672 37.0607 82.637 37.1628 83.2495 37.8135C84.2193 38.8471 85.0743 40.0083 85.8144 41.2844C86.5545 42.5604 87.1287 43.8875 87.537 45.2401C87.805 46.0951 87.3967 46.9883 86.6183 47.4349L83.4282 49.2724C83.4792 49.7828 83.5175 50.306 83.5175 50.8419C83.5175 51.3779 83.492 51.8883 83.4282 52.4115L86.6183 54.249C87.3967 54.6956 87.7922 55.5888 87.537 56.4438C87.1159 57.7964 86.5417 59.1234 85.8144 60.3995C85.087 61.6755 84.2193 62.8367 83.2495 63.8703C82.637 64.5211 81.6545 64.6232 80.8889 64.1766L77.7115 62.3518C76.831 63.0026 75.8868 63.5513 74.8659 63.9852V67.8898C74.8659 68.7831 74.2917 69.587 73.424 69.7784C72.0842 70.0846 70.6805 70.2505 69.2514 70.2505C67.8222 70.2505 66.4185 70.0846 65.0787 69.7784C64.211 69.587 63.6368 68.7831 63.6368 67.8898V63.9979C62.6159 63.5641 61.6461 63.0154 60.7657 62.3518L57.6139 64.1766C56.8355 64.6232 55.8657 64.5211 55.2532 63.8703C54.2834 62.8367 53.4284 61.6755 52.6883 60.3995C51.9482 59.1234 51.374 57.7964 50.9657 56.4438C50.6977 55.5888 51.106 54.6956 51.8844 54.249L55.049 52.4242C54.998 51.901 54.9597 51.3779 54.9597 50.8419C54.9597 50.306 54.9852 49.7828 55.049 49.2596L51.8717 47.4221C51.0933 46.9755 50.6977 46.0823 50.9529 45.2273C51.374 43.8747 51.9355 42.5477 52.6756 41.2716C53.4157 39.9956 54.2706 38.8344 55.2404 37.8008C55.8529 37.15 56.8227 37.0479 57.6011 37.4945L60.7657 39.3193C61.6461 38.6685 62.6159 38.1198 63.6368 37.6732V33.7813V33.794ZM75.3891 50.8292C75.4269 50.0005 75.2964 49.1727 75.0053 48.3958C74.7142 47.619 74.2687 46.9092 73.6956 46.3094C73.1225 45.7096 72.4338 45.2322 71.671 44.906C70.9083 44.5798 70.0873 44.4116 69.2577 44.4116C68.4282 44.4116 67.6072 44.5798 66.8444 44.906C66.0817 45.2322 65.3929 45.7096 64.8199 46.3094C64.2468 46.9092 63.8013 47.619 63.5102 48.3958C63.2191 49.1727 63.0885 50.0005 63.1264 50.8292C63.0885 51.6579 63.2191 52.4857 63.5102 53.2625C63.8013 54.0393 64.2468 54.7491 64.8199 55.3489C65.3929 55.9488 66.0817 56.4262 66.8444 56.7524C67.6072 57.0785 68.4282 57.2467 69.2577 57.2467C70.0873 57.2467 70.9083 57.0785 71.671 56.7524C72.4338 56.4262 73.1225 55.9488 73.6956 55.3489C74.2687 54.7491 74.7142 54.0393 75.0053 53.2625C75.2964 52.4857 75.4269 51.6579 75.3891 50.8292Z'
			stroke='#00C0F3'
			strokeWidth='4'
		/>
	</svg>
);

const CalendarPlusSVG = () => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='110'
		height='120'
		viewBox='0 0 74 78'
		fill='none'>
		<path
			d='M4 26.1053V62.9474C4 64.9016 4.77631 66.7758 6.15816 68.1576C7.54001 69.5395 9.41419 70.3158 11.3684 70.3158H33.4737M4 26.1053V18.7368C4 16.7826 4.77631 14.9084 6.15816 13.5266C7.54001 12.1447 9.41419 11.3684 11.3684 11.3684H18.7368M4 26.1053H62.9474M18.7368 11.3684H48.2105M18.7368 11.3684V4M62.9474 26.1053V18.7368C62.9474 16.7826 62.1711 14.9084 60.7892 13.5266C59.4074 12.1447 57.5332 11.3684 55.5789 11.3684H48.2105M62.9474 26.1053V37.1579M48.2105 11.3684V4'
			stroke='white'
			strokeWidth='7.36842'
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
		<path
			d='M59.0526 52V63.0526M59.0526 63.0526V74.1053M59.0526 63.0526H70.1053M59.0526 63.0526H48'
			stroke='#00C0F3'
			strokeWidth='7.36842'
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
	</svg>
);

const ClipboardCheckSVG = () => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='100'
		height='110'
		viewBox='0 0 96 99'
		fill='none'>
		<path
			d='M63.9963 91.5574C62.8247 92.729 60.9252 92.729 59.7537 91.5574L42.9588 74.7626C41.7872 73.591 41.7872 71.6915 42.9588 70.5199L45.6462 67.8326C46.8177 66.661 48.7172 66.661 49.8888 67.8326L61.875 79.8187L87.7212 53.9726C88.8927 52.801 90.7922 52.801 91.9638 53.9726L94.6512 56.6599C95.8227 57.8315 95.8227 59.731 94.6512 60.9026L63.9963 91.5574ZM89.1 41.55C89.1 43.2069 87.7569 44.55 86.1 44.55H82.2C80.5431 44.55 79.2 43.2069 79.2 41.55V22.8C79.2 21.1431 77.8568 19.8 76.2 19.8H72.3C70.6431 19.8 69.3 21.1431 69.3 22.8V31.65C69.3 33.3069 67.9568 34.65 66.3 34.65H22.8C21.1431 34.65 19.8 33.3069 19.8 31.65V22.8C19.8 21.1431 18.4569 19.8 16.8 19.8H12.9C11.2431 19.8 9.9 21.1431 9.9 22.8V86.1C9.9 87.7569 11.2431 89.1 12.9 89.1H36.6C38.2569 89.1 39.6 90.4431 39.6 92.1V96C39.6 97.6569 38.2569 99 36.6 99H9.9C7.1775 99 4.8477 98.0314 2.9106 96.0943C0.9735 94.1572 0.0033 91.8258 0 89.1V19.8C0 17.0775 0.9702 14.7477 2.9106 12.8106C4.851 10.8735 7.1808 9.9033 9.9 9.9H30.5662C31.4737 7.0125 33.2475 4.64145 35.8875 2.78685C38.5275 0.93225 41.415 0.0033 44.55 0C47.85 0 50.8002 0.92895 53.4006 2.78685C56.001 4.64475 57.7533 7.0158 58.6575 9.9H79.2C81.9225 9.9 84.2539 10.8702 86.1943 12.8106C88.1347 14.751 89.1033 17.0808 89.1 19.8V41.55ZM44.55 19.8C45.9525 19.8 47.1289 19.3248 48.0793 18.3744C49.0298 17.424 49.5033 16.2492 49.5 14.85C49.4967 13.4508 49.0215 12.276 48.0744 11.3256C47.1273 10.3752 45.9525 9.9 44.55 9.9C43.1475 9.9 41.9727 10.3752 41.0256 11.3256C40.0785 12.276 39.6033 13.4508 39.6 14.85C39.5967 16.2492 40.0719 17.4256 41.0256 18.3793C41.9793 19.333 43.1541 19.8066 44.55 19.8Z'
			fill='white'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M40.8375 72.6412L61.875 93.6787L96.7725 58.7812L89.8425 51.8512L61.875 79.8187L47.7675 65.7112L40.8375 72.6412Z'
			fill='#00C0F3'
		/>
	</svg>
);

// Configuração centralizada de todos os cards
const SuppliesSVG = () => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='165'
		height='165'
		viewBox='0 0 80 80'
		className='-translate-y-3'
		fill='none'>
		<path
			d='M14 27L40 13L66 27L40 41L14 27Z'
			stroke='white'
			strokeWidth='5'
			strokeLinejoin='round'
		/>
		<path
			d='M14 27V55L40 69V41'
			stroke='white'
			strokeWidth='5'
			strokeLinejoin='round'
		/>
		<path
			d='M66 27V55L40 69'
			stroke='white'
			strokeWidth='5'
			strokeLinejoin='round'
		/>
		<path
			d='M28 21L54 35'
			stroke='#00C0F3'
			strokeWidth='5'
			strokeLinecap='round'
		/>
		<path
			d='M22 48L31 53'
			stroke='#00C0F3'
			strokeWidth='5'
			strokeLinecap='round'
		/>
	</svg>
);

const CARDS_CONFIG = [
	{
		id: 'escala',
		name: 'Escala de Profissionais',
		link: '/escala',
		image: EscalaPNG,
		imageType: 'img',
		order: 1,
		permissions: {
			allowedFor: ['all'],
		},
	},
	{
		id: 'paineis',
		name: 'Painéis de Monitoramento',
		link: '/paineis-de-monitoramento',
		image: PaineisPNG,
		imageType: 'img',
		order: 2,
		permissions: {
			allowedFor: ['all'],
		},
	},
	{
		id: 'hci',
		name: 'HCI',
		link: 'https://hci.rio.gov.br/auth/sign-in',
		image: HCIPNG,
		imageType: 'img',
		imageClass: 'w-full h-full object-contain scale-150',
		external: true,
		order: 3,
		permissions: {
			allowedFor: ['all'],
		},
	},
	{
		id: 'calculo',
		name: 'Memória de Cálculo',
		link: '/hub',
		image: CalculoPNG,
		imageType: 'img',
		order: 4,
		permissions: {
			deniedFor: [
				'Daniel Lopes da Mata',
				'sms',
				'subhue',
				'gestor',
				'usuario',
			],
		},
	},
	{
		id: 'agenda',
		name: 'Agenda Interna SUBHUE',
		link: '/calendario-interno',
		image: CalendarioPNG,
		imageType: 'img',
		order: 6,
		permissions: {
			allowedFor: ['Daniel Lopes da Mata', 'subhue', 'desenvolvedor'],
		},
	},
	{
		id: 'permissoes',
		name: 'Permissões de Usuários',
		image: GearSVG,
		imageType: 'svg',
		link: '/permissionador',
		order: 7,
		permissions: {
			allowedFor: ['gestor', 'desenvolvedor'],
		},
	},
	{
		id: 'visualizador',
		name: 'Visualizador de Escalas',
		link: '/admin-visualize',
		image: EscalaPNG,
		imageType: 'img',
		imageClass: 'w-[30px] h-[30px]',
		order: 8,
		permissions: {
			deniedFor: ['all'],
		},
	},
	{
		id: 'adicionar-evento',
		name: 'Adicione novo evento SUBHUE',
		image: CalendarPlusSVG,
		imageType: 'svg',
		link: '/calendar-form',
		order: 9,
		permissions: {
			allowedFor: ['Daniel Lopes da Mata', 'subhue', 'desenvolvedor'],
		},
	},
	{
		id: 'monitoramento-leitos',
		name: 'Monitoramento de Leitos',
		link: '/monitoramento-leitos',
		image: Monitoramento,
		imageType: 'img',
		imageClass: 'w-[155px] h-[140px]',
		order: 10,
		permissions: {
			allowedFor: ['subhue', 'desenvolvedor'],
		},
	},
	{
		id: 'notificacoes',
		name: 'Notificações de Incidentes',
		image: ClipboardCheckSVG,
		imageType: 'svg',
		link: '/notes-avaliation',
		order: 11,
		permissions: {
			allowedFor: ['all', 'subhue'],
			requiredPermission: [
				'Classificadores',
				'Investigadores',
				'Gestores',
			],
		},
	},
	{
		id: 'biblioteca',
		name: 'Gestão de Biblioteca',
		link: '/gestao-biblioteca',
		image: GestaoBiblioteca,
		imageType: 'img',
		order: 12,
		permissions: {
			allowedFor: ['subhue', 'desenvolvedor'],
		},
	},
	{
		id: 'safety-huddle',
		name: 'Safety Huddle',
		image: SafetyHuddlePNG,
		imageType: 'img',
		link: '/safety-huddle',
		order: 13,
		permissions: {
			// Desenvolvedores têm acesso administrativo; os demais usuários
			// precisam da permissão funcional concedida pelo permissionador.
			allowedFor: ['all', 'desenvolvedor'],
			requiredPermission: ['SafetyHuddle'],
		},
	},

	{
		id: 'ocupacao_de_leitos',
		name: 'Ocupação de Leitos',
		link: '/monitoramento-subhue',
		image: MonitoramentoSUBHUE,
		imageType: 'img',
		imageClass: 'w-[155px] h-[140px]',
		order: 14,
		permissions: {
			allowedFor: ['subhue', 'desenvolvedor'],
		},
	},
	{
		id: 'parcerias',
		name: 'Gestão de Parcerias',
		link: '/gestao-parcerias',
		image: Parcerias,
		imageType: 'img',
		imageClass: '',
		order: 15,
		permissions: {
			allowedFor: ['desenvolvedor'],
		},
	},
	{
		id: 'insumos-timed',
		name: 'Insumos TIMED',
		link: '/insumos',
		image: SuppliesSVG,
		imageType: 'svg',
		order: 17,
		permissions: {
			allowedFor: ['subhue', 'desenvolvedor', 'smsrio', 'sms rio', 'sms'],
		},
	},
	{
		id: 'acompanhamento-avc',
		name: 'Acompanhamento AVC',
		link: '/avc',
		image: AvcAcompanhamentoIcon,
		imageType: 'img',
		order: 18,
		permissions: {
			allowedFor: [
				'all',
				'subhue',
				'desenvolvedor',
				'smsrio',
				'sms rio',
				'sms',
			],
			requiredPermission: ['AVC'],
		},
	},
];

function ICards() {
	const [visibleCards, setVisibleCards] = useState([]);

	let user;
	if (Cookies.get('user')) {
		user = JSON.parse(Cookies.get('user'));
	}

	// Função para verificar se o usuário pode ver o card
	const normalizePermissionValue = (value = '') =>
		String(value || '')
			.normalize('NFD')
			.replace(/[\u0300-\u036f]/g, '')
			.toLowerCase()
			.trim();

	const userPermissionValues = [
		user?.nome,
		user?.unidade,
		user?.cargo,
		...(Array.isArray(user?.permissao)
			? user.permissao
			: [user?.permissao].filter(Boolean)),
	];

	const permissionListIncludesUser = (permissionList = []) => {
		const normalizedUserValues = userPermissionValues.map(
			normalizePermissionValue,
		);

		return permissionList.some((permission) =>
			normalizedUserValues.includes(normalizePermissionValue(permission)),
		);
	};

	const canAccessAvcHub = permissionListIncludesUser([
		'subhue',
		'desenvolvedor',
		'smsrio',
		'sms rio',
		'sms',
	]);

	const canUserSeeCard = (card) => {
		const { permissions } = card;
		// DENY sempre vem primeiro
		if (permissions.deniedFor) {
			if (permissions.deniedFor.includes('all')) return false;
			if (permissionListIncludesUser(permissions.deniedFor)) return false;
		}

		// ALLOW explícito (ignora requiredPermission)
		if (permissionListIncludesUser(permissions.allowedFor)) {
			return true;
		}

		// allowedFor = all → valida permissão
		if (permissions.allowedFor?.includes('all')) {
			if (permissions.requiredPermission) {
				if (Array.isArray(permissions.requiredPermission)) {
					return permissions.requiredPermission.some((p) =>
						user?.permissao?.includes(p),
					);
				}
				return user?.permissao?.includes(
					permissions.requiredPermission,
				);
			}
			return true;
		}

		return false;
	};

	// Filtra e ordena os cards visíveis
	useEffect(() => {
		const filtered = CARDS_CONFIG.filter(canUserSeeCard).sort(
			(a, b) => a.order - b.order,
		);

		setVisibleCards(filtered);
	}, []);

	// Renderiza a imagem do card
	const renderCardImage = (card) => {
		if (card.imageType === 'svg') {
			const SvgComponent = card.image;
			return <SvgComponent />;
		}

		return (
			<img
				alt={card.name}
				src={card.image}
				className={card.imageClass || ''}
			/>
		);
	};

	const renderCard = (card) => (
			<a
				key={card.id}
				rel='noopener noreferrer'
				target={card.external ? '_blank' : '_self'}
				href={
					card.id === 'acompanhamento-avc' && !canAccessAvcHub
						? '/avc/acompanhamento'
						: card.link
				}
				className='flex flex-row md:scale-100 justify-center w-[250px] h-[200px] md:w-[200px] md:h-[240px] hover:no-underline hover:scale-11 cursor-pointer rounded-sm transform transition duration-300 hover:scale-110'>
				<div className='hover:no-underline flex flex-col items-center justify-between transform transition duration-300 hover:scale-105 md:h-[240px] md:w-[105%] w-[80%] bg-[#F5F5F5] rounded-md shadow-md'>
					<div className='flex justify-start bg-[#004A80] w-full mb-[7px] rounded-t-md h-[128px]'>
						<div className='flex justify-center w-full md:scale-[55%] scale-[48%]'>
							{renderCardImage(card)}
						</div>
					</div>
					<div className='h-[2px] w-[80%] bg-[#D9D9D9]'></div>
					<p className='font-semibold mx-1 my-auto px-1 text-[#757575]'>
						{card.name}
					</p>
				</div>
			</a>
		);

	return (
		<div className='flex items-center mt-[8%] mb-[5%] md:mt-[2%] w-100 xl:mb-[3%] 2xl:mb-[10%]'>
			<div className='flex flex-col md:flex-row md:flex-wrap gap-10 md:gap-[36px] justify-center items-center w-full '>
				{visibleCards.map(renderCard)}
			</div>
		</div>
	);
}

export default ICards;
